import { InputLabel, MenuItem } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useFormikContext } from "formik";
import { ReactElement } from "react";

import { useTenant } from "~frontend/providers/LoggedInUserProvider";

import { FlexBox } from "../FlexBox";
import { FormikSelect } from "./FormSelect";
import { FormikTextField } from "./FormTextField";

export function timeToHHMM(hhmmss: string): string {
  return hhmmss.substring(0, 5);
}

export function timeFromHHMM(hhmm: string): string {
  if (hhmm) {
    return `${hhmm}:00`;
  }

  return "";
}

export default function FormikTextingHoursFields({
  startTimeFieldName = "textingHoursStart",
  endTimeFieldName = "textingHoursEnd",
  timezoneFieldName = "textingHoursTimezone",
  disabled = false,
  label = null,
}: {
  startTimeFieldName?: string;
  endTimeFieldName?: string;
  timezoneFieldName?: string;
  disabled?: boolean;
  label?: string | null;
}): ReactElement {
  const { values, setFieldValue } = useFormikContext<any>();
  const theme = useTheme();
  const tenant = useTenant()!;

  const inlineFormControlStyle = {
    paddingTop: 0,
    minWidth: "140px",
    flex: "1 0 0",
  };

  return (
    <div>
      {label && (
        <InputLabel shrink sx={{ mb: -1.25 }}>
          {label}
        </InputLabel>
      )}
      <FlexBox alignItems="baseline" data-testid="texting-hours">
        <FormikTextField
          data-testid="texting-hours-start"
          type="time"
          name={startTimeFieldName}
          disabled={disabled}
          value={timeToHHMM(values[startTimeFieldName])}
          sx={inlineFormControlStyle}
          onChange={e => {
            const value = e.target.value || "";
            setFieldValue(startTimeFieldName, timeFromHHMM(value)).catch(
              console.error
            );
          }}
        />
        <span
          style={{
            display: "inline-block",
            padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
          }}
        >
          to
        </span>
        <FormikTextField
          data-testid="texting-hours-end"
          type="time"
          name={endTimeFieldName}
          disabled={disabled}
          value={timeToHHMM(values[endTimeFieldName])}
          sx={inlineFormControlStyle}
          onChange={e => {
            const value = e.target.value || "";
            setFieldValue(endTimeFieldName, timeFromHHMM(value)).catch(
              console.error
            );
          }}
        />
        <FormikSelect
          sx={{
            marginLeft: theme.spacing(3),
            width: "270px",
            ...inlineFormControlStyle,
          }}
          name={timezoneFieldName}
          disabled={disabled}
          data-testid="texting-hours-timezone"
        >
          {tenant.timezoneOptions.map(({ displayName, timezone }) => (
            <MenuItem key={timezone} value={timezone}>
              {displayName}
            </MenuItem>
          ))}
        </FormikSelect>
      </FlexBox>
    </div>
  );
}
